import { getConfigWithMetadata } from '@pkgs/api/utils/headers';
import { getErrorResult } from '@pkgs/api/utils';
import { type ApiConfig, type ApiResult } from '@pkgs/api/types';
import { type InputContact } from '@generated/search-api/models/inputContact';
import {
  listingLead as generatedListingLead,
  type ListingLeadResult as GeneratedListingLeadResult,
} from '@generated/search-api/controllers/eVSearchV3API';
import { type OutputLeadResponse } from '@generated/search-api';
/**
 * Lead contact form to request further information, viewing, callback, etc. for a certain listing using the `/api/v3/listing/{listingId}/lead` endpoint.
 *
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/leads/listingLead Search API Documentation}
 */
export const listingLead = async (
  listingId: string,
  inputContact: InputContact,
  apiConfig: ApiConfig,
): Promise<ApiResult<OutputLeadResponse>> => {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'listingLead');
    const data = await generatedListingLead(listingId, inputContact, _apiConfig);

    return {
      status: 'success',
      data,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
};

export type listingLeadResult = GeneratedListingLeadResult;
